import { APPENV } from "@/config/env";
import { API } from "@/lib/axios";
import { IChatBotLiveConfig } from "../services/chatbotConfigGenerator";

export const postProductConfigurationJsonApi = (body: any) => {
  return API.post(`api/config/upload?code=${APPENV.POST_APP_JSON_CODE}`, body);
};

export const getProductConfigurationJsonApi =
  async (): Promise<IChatBotLiveConfig> => {
    const respose = await API.get(
      `api/config/latest?code=${APPENV.GET_APP_JSON_CODE}`
    );
    return respose.data;
  };

export interface IConfigVersionsResponse {
  count: number;
  versions: string[];
}

export const getConfigVersionsApi = async (): Promise<IConfigVersionsResponse> => {
  const response = await API.get(
    `api/config/versions?code=${APPENV.GET_APP_JSON_CODE}`
  );
  return response.data;
};

export const getConfigByVersionApi = async (version: string): Promise<IChatBotLiveConfig> => {
  const response = await API.get(
    `api/config/latest?version=${version}&code=${APPENV.GET_APP_JSON_CODE}`
  );
  return response.data;
};

export const putConfigLiveApi = async (body: IChatBotLiveConfig): Promise<any> => {
  const response = await API.put(
    `api/config/live?code=${APPENV.GET_APP_JSON_CODE}`,
    body
  );
  return response.data;
};

export const postConfigUploadOverwriteApi = async ({
  body,
  version,
}: {
  body: IChatBotLiveConfig;
  version: string;
}): Promise<any> => {
  const response = await API.post(
    `api/config/upload?overwrite=true&blobName=${version}&code=${APPENV.POST_APP_JSON_CODE}`,
    body
  );
  return response.data;
};
